import { render, staticRenderFns } from "./stockItemStatusBox.vue?vue&type=template&id=e23b19dc&"
import script from "./stockItemStatusBox.vue?vue&type=script&lang=ts&"
export * from "./stockItemStatusBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports